<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <CRow>
      <CCol col="12">
        <ChapterSelect
          :funcCountChat="countDefaultChat"
          :funcRoute="funcRoute"
          :content="content"
          :mainContent="show"
          :chapterProgress="chapterProgress"
          :pageCode="pageCode"
          :checkExam="checkExam"
          :loading="loading"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ChapterSelect from './components/ChapterSelect.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';

export default {
  components: {ChapterSelect},
  name: 'HP02',

  data() {
    return {
      show: {},
      content: [],
      Intro: [],
      popUpImage: [],
      popUpImageTwo: [],
      type: '',
      CheckFirstPage: 'first',
      code: '',
      CheckWidth: window.innerWidth.toString(),
      defaultChat: false,
      checkAnswer: true,
      courseCode: '',
      chapterProgress: {},
      pageCode: '',
      checkExam: [],
      courseSection: '',
      startTime: '',
      loading: true,
      mockChapterProgress: {
        code: 'HP02-1',
        contentId: '',
        courseId: '',
        lock: false,
        number: 2,
        percent: 100,
        progress: 12,
        template: [],
      },
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates', //เรียก template มาแสดง
      V3GetCourseProgress: 'v3/getCourseProgress', //เรียก progress มาแสดง
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },
  watch: {
    getTemplatev3(val) {
      this.loading = true;
      if (!val) return;

      const template = val.templates[0];

      this.show = val.templates[0];
      this.v3Data = val.templates[0];

      this.$store.dispatch('v3/v3GetParent', val.codeItem);
      //get Progress
      this.onLoadProgress();
    },
    V3GetCourseProgress: function (val) {
      if (!val) return;

      this.chapterProgress = val.subProgress;
      this.loading = false;
    },

    saveContentStatusv4: function () {
      console.log('save content respond');

      //get Progress after watch trigger
      this.onLoadData();
    },
  },
  created() {},
  mounted() {
    if (
      this.$store.state.v4.v4CurrentMainCodeItem &&
      this.$store.state.v4.v4DataStack.length !== 0
    ) {
      // console.log('pigeon run!');

      this.$store.dispatch('v4/forceSavePayload', {
        mainCodeItem: this.$store.state.v4.v4CurrentMainCodeItem,
        mainType: this.$store.state.v4.v4MainType,
        mainContent: this.$store.state.v4.v4MainContent,
        dataStack: this.$store.state.v4.v4DataStack,
        pages: this.$store.state.v4.v4Pages,
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
      });
    } else {
      this.onLoadData();
    }
  },

  beforeDestroy() {},
  methods: {
    v3ManageData() {},
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 500) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 500) {
        return 'container-chinese-card-mobile';
      }
    },
    onLoadData() {
      this.loading = true;

      this.startTime = this.$helpers.getDateFormat();

      //loadfor non display route
      const contentId = `HP02-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
      //
    },
    onLoadProgress() {
      // เรียก progress มาแสดง
      const payload = {
        codeItem: this.$store.state.v3.templates.templates[0].codeTemplate,
        courseId: this.$store.state.necessary.learningCourse,
      };

      // console.log(payload, 'courseprogress');

      this.$store.dispatch('v3/fetchCourseProgress', payload); // เรียก progress มาแสดงจาก backend --> ไปที่ Watch เพื่อเช็คข้อมูล
    },
    funcRoute(tempId) {
      this.loading = true;

      this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage

      //stamp main code item

      this.$store.commit('v3/stampMainCodeItem', tempId); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล

      const pathFormat = tempId.split('-');
      this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
    },
    closeModal() {
      this.openModalConver = !this.openModalConver;
    },
    countDefaultChat() {
      return (this.defaultChat = true);
    },
    // commitPayloadData() {
    //   //for v4 planned ?
    //   //payload here
    //   const payload = {
    //     codeItem: this.v3Data.codeItem,
    //   };

    //   //commit add payload stack
    //   this.$store.commit('v4/addPayloadStack', payload);
    //   //var
    //   const dataStack = this.$store.state.v4.v4DataStack;
    //   const currentCodeItem = this.v3Data.codeItem;
    //   //get last code item form backend
    //   const lastCodeItem = this.v3Data.lastContent;
    //   //check store
    //   if (dataStack.length === 0) {
    //     //no dispatch if array empty
    //   } else {
    //     if (currentCodeItem === lastCodeItem) {
    //       this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
    //         mainCodeItem: this.v3Data.mainCodeItem,
    //         mainType: this.v3Data.mainType,
    //         mainContent: this.v3Data.mainContent,
    //         dataStack: this.$store.state.v4.v4DataStack,
    //         pages: this.v3Data.pages,
    //         courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
    //         section: this.$store.state.v3.v3EnrollData.data.section,
    //       });
    //     }
    //     //if not just clear stack
    //   }
    // },
  },
};
</script>

<style>
.displayNone {
  display: None;
}

.displayBlock {
  display: block;
}
</style>
